/**
 * Tracks one in-flight read request per UI interaction.
 * Superseded or cancelled requests may resolve, but must not update the current view.
 * This is a client-side display safeguard; server-side authorization is still mandatory.
 */
export function createGeoRequestGate() {
  let active = null;
  return {
    start() {
      active?.abort();
      active = new AbortController();
      return active;
    },
    isCurrent(controller) {
      return controller != null && active === controller && !controller.signal.aborted;
    },
    cancel() {
      active?.abort();
      active = null;
    },
  };
}
